<template>
  <DSAReportLandingPage />
</template>
  
  <script>
  import DSAReportLandingPage from '@/DSAReportComponents/DSAReportLandingPage.vue';
  
  export default {
    name: 'DSAReport',
    components: {
      DSAReportLandingPage
    }
  };
  </script>
  